import { Injectable } from '@angular/core';
import {environment} from '../../../environments/environment';
import {
  AnalyticOperation,
  AnalyticOperationCreate,
  ColumnValuesPayload,
  ColumnValuesResponse,
  GetParams,
  GetResponse,
  PostResponse
} from '@app/shared';
import {Observable} from 'rxjs';
import {convertGetParamsToHttpParams} from '@app/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AnalyticOperationService {
  /** URLs principales relacionadas con AnalyticOperation **/
  analyticOperationUrl = environment.coreApiBaseUrl + '/api/AnalyticOperation';
  constructor(private http: HttpClient) { }

  /** Metodos de obtener/crear/actualizar/eliminar AnalyticOperation **/
  getAnalyticOperation(getParams: GetParams): Observable<GetResponse> {
    return this.http.get<GetResponse>(this.analyticOperationUrl, {params: convertGetParamsToHttpParams(getParams)});
  }

  getAnalyticOperationColumnValues<TColumn extends string = string>(
    payload: ColumnValuesPayload<TColumn>
  ): Observable<ColumnValuesResponse<TColumn>> {
    return this.http.post<ColumnValuesResponse<TColumn>>(
      `${this.analyticOperationUrl}/column-values`,
      payload
    );
  }

  createAnalyticOperation(newAnalyticOperation: AnalyticOperationCreate): Observable<PostResponse> {
    return this.http.post<PostResponse>(this.analyticOperationUrl, newAnalyticOperation);
  }

  updateAnalyticOperation(analyticOperation: AnalyticOperation): Observable<any> {
    return this.http.put(this.analyticOperationUrl, analyticOperation);
  }

  deleteAnalyticOperation(analyticOperationsIds: number[]): Observable<any> {
    return this.http.delete(this.analyticOperationUrl, {body: {ids: analyticOperationsIds}});
  }

  duplicateAnalyticOperation(serviceOrderId:number ,analyticOperationsIds: number[], targetClass:string): Observable<any> {
    return this.http.post<PostResponse>(this.analyticOperationUrl+'/duplicate', {
      serviceOrderId,
      analyticOperationsIds,
      targetClass
    });
  }
  calculateAmount(quantity:number, type:string):Observable<any> {
    return this.http.get<GetResponse>(this.analyticOperationUrl+'/calculateAmount', {
      params: {
        quantity: quantity.toString(),
        type: type
      }
    });
  }

  patchMassiveClassAO(data: {ids: number[], class: string}) {
    return this.http.patch(this.analyticOperationUrl + '/batch', data);
  }


}
